import { TableCell, withStyles } from '@material-ui/core';

export const TableCellHeading = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.background.default,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
}))(TableCell);
